import styled from 'styled-components';
import { Input, InputNumber } from 'antd';

const { TextArea, Password } = Input;

export const InputStyled = styled(Input)`
  background-color: #f5f8fa;
  border-color: #f5f8fa;
  color: #5e6278;
  transition: color 0.2s ease, background-color 0.2s ease;
  min-height: calc(1.5em + 1.65rem + 2px);
  padding: 0.825rem 1.5rem;
  font-size: 1.15rem;
  border-radius: 0.625rem;
  &:focus {
    background-color: #eef3f7;
    border-color: #eef3f7;
    color: #5e6278;
    transition: color 0.2s ease, background-color 0.2s ease;
    box-shadow: none;
  }
  &:hover {
    box-shadow: none;
    border-color: #f5f8fa;
  }
`;

export const InputNumberStyled = styled(InputNumber)``;

export const TextAreaStyled = styled(TextArea)`
  background-color: #f5f8fa;
  font-size: 1.15rem;
  border-radius: 0.625rem;
  box-shadow: none;
  border-color: #f5f8fa;
  padding: 1rem;
`;

export const PasswordStyled = styled(Password)`
  background-color: #f5f8fa;
  border-color: #f5f8fa;
  transition: color 0.2s ease, background-color 0.2s ease;
  min-height: calc(1.5em + 1.65rem + 2px);
  padding: 0.825rem 1.5rem;
  border-radius: 0.625rem;
  .ant-input {
    background-color: #f5f8fa;
    color: #5e6278;
    font-size: 1.15rem;
  }
`;
